import * as ambassadorWixMembersV1MemberPrivacySettings from './members-v1-member-privacy-settings-member-privacy-settings.http.js';
import * as ambassadorWixMembersV1MemberPrivacySettingsTypes from './members-v1-member-privacy-settings-member-privacy-settings.types.js';
import * as ambassadorWixMembersV1MemberPrivacySettingsUniversalTypes from './members-v1-member-privacy-settings-member-privacy-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getMemberPrivacySettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV1MemberPrivacySettingsUniversalTypes.GetMemberPrivacySettingsRequest,
  ambassadorWixMembersV1MemberPrivacySettingsTypes.GetMemberPrivacySettingsRequest,
  ambassadorWixMembersV1MemberPrivacySettingsUniversalTypes.GetMemberPrivacySettingsResponse,
  ambassadorWixMembersV1MemberPrivacySettingsTypes.GetMemberPrivacySettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1MemberPrivacySettings.getMemberPrivacySettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/privacy-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setMemberPrivacySettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberPrivacySettingsUniversalTypes.SetMemberPrivacySettingsRequest,
  ambassadorWixMembersV1MemberPrivacySettingsTypes.SetMemberPrivacySettingsRequest,
  ambassadorWixMembersV1MemberPrivacySettingsUniversalTypes.SetMemberPrivacySettingsResponse,
  ambassadorWixMembersV1MemberPrivacySettingsTypes.SetMemberPrivacySettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1MemberPrivacySettings.setMemberPrivacySettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/privacy-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  MemberPrivacySettings as MemberPrivacySettingsOriginal,
  Visibility as VisibilityOriginal,
  VisibilityWithLiterals as VisibilityWithLiteralsOriginal,
  Candidates as CandidatesOriginal,
  CandidatesWithLiterals as CandidatesWithLiteralsOriginal,
  GetMemberPrivacySettingsRequest as GetMemberPrivacySettingsRequestOriginal,
  GetMemberPrivacySettingsResponse as GetMemberPrivacySettingsResponseOriginal,
  BulkGetMemberPrivacySettingsRequest as BulkGetMemberPrivacySettingsRequestOriginal,
  BulkGetMemberPrivacySettingsResponse as BulkGetMemberPrivacySettingsResponseOriginal,
  SiteMemberInstanceMemberPrivacySettings as SiteMemberInstanceMemberPrivacySettingsOriginal,
  SetMemberPrivacySettingsRequest as SetMemberPrivacySettingsRequestOriginal,
  SetMemberPrivacySettingsResponse as SetMemberPrivacySettingsResponseOriginal,
  InvalidRevisionPayload as InvalidRevisionPayloadOriginal,
  InvalidSettingsPayload as InvalidSettingsPayloadOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  SetMemberPrivacySettingsApplicationErrors as SetMemberPrivacySettingsApplicationErrorsOriginal,
} from './members-v1-member-privacy-settings-member-privacy-settings.types.js';
